// extracted by mini-css-extract-plugin
export default {"loading_animation":"loading_animation_loading_animation__MlfFH","rotate_loading":"loading_animation_rotate_loading__t4VIx"};